'use strict';

var ServiceAdjustmentFareAggregationFactory = function ServiceAdjustmentFareAggregationFactory(DataAggregationFactory) {
  function ServiceAdjustmentFareAggregation() {
    DataAggregationFactory.call(this, 'service-share', 'demand-adjustment-fare');
  }
  function getKey(item) {
    return item.entry.className + ' (' + item.fare + ')';
  }
  ServiceAdjustmentFareAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ServiceAdjustmentFareAggregation.constructor = ServiceAdjustmentFareAggregation;
  ServiceAdjustmentFareAggregation.prototype.aggregate = function (data) {
    var aggregatedFare = {};
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var item = data[index];
      var keyName = getKey(item);
      if (!aggregatedFare[keyName]) {
        aggregatedFare[keyName] = [];
      }
      aggregatedFare[keyName].push(item);
    }
    return aggregatedFare;
  };
  return ServiceAdjustmentFareAggregation;
};
ServiceAdjustmentFareAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = ServiceAdjustmentFareAggregationFactory;